"use client";

export default function PoweringProgress() {
  return <></>;
}